import React, { useState } from "react";
import SingleChatSideBarHeader from "../../../Components/MainChatSideBarHeader/SingleChatSideBarHeader";
import SettingsList from "./SettingsList/SettingsList";
import SettingsView from "./SettingView/SettingsView";
import SettingsEdit from "./SettingsEdit/SettingsEdit";
import { IoChevronBack } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { postFormDataApiCaller } from "../../../Libs/apiCaller";
import { logedInUser } from "../../../Redux/slices/AuthSlice";

export default function SettingsSideBar() {
  const [view, setView] = useState("list"); // Default to the list view
  const [isLoading, setIsLoading] = useState();
  const dispatch = useDispatch();

  const handleUpdateProfile = async (data) => {
    setIsLoading(true);
    const formData = new FormData();
    data.imageFile &&
      typeof data.imageFile !== "string" &&
      formData.append("UserMedia", data.imageFile);
    data.imageFile &&
      typeof data.imageFile === "string" &&
      formData.append("avtarId", data.imageFile);
    formData.append("name", data.fullName);
    formData.append("userName", data.userName);
    formData.append("email", data.email);
    formData.append("phone", data.phone);
    formData.append("gender", data.gender);
    formData.append("about", data.about);
    formData.append("privacy", data.visibility);
    const endPoint = "users/update_user";
    const response = await postFormDataApiCaller(endPoint, formData);
    if (response?.status === 200) {
      dispatch(logedInUser(response.data.user));
      toast.success("Profile updated successfully");
      setView("view");
    } else {
      toast.error(response?.response?.data?.message || response?.message);
    }
    setIsLoading(false);
  };

  return (
    <section className="w-full">
      {/* Header */}
      <div className="sticky top-0 z-10 w-full min-h-[67px] py-2.5 bg-white dark:bg-slate-900 flex flex-row-reverse items-center justify-end border-b border-zinc-200 dark:border-slate-700 text-black dark:text-zinc-100 p-4">
        <h1 className="text-lg font-semibold">Settings</h1>
        {view !== "list" && (
          <button onClick={() => setView(view === "edit" ? "view" : "list")}>
            <IoChevronBack size={24} className="mr-3" />
          </button>
        )}
      </div>

      <div className="p-4 h-[calc(100vh-80px)] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200">
        {view === "list" && <SettingsList setView={setView} />}
        {view === "view" && <SettingsView setView={setView} />}
        {view === "edit" && (
          <SettingsEdit
            setView={setView}
            isLoading={isLoading}
            handleUpdateProfile={handleUpdateProfile}
          />
        )}
      </div>
    </section>
  );
}
